<!-- Purpose and Country -->
<div class="row">
    <div class="col-6" *ngIf="!defaultAddressTypeName">
        <tsl-form-field class="w-100">
            <tsl-label i18n="@@a84f3646a8c60c604fb019e90a90a551a6cf0ba6" t="a84f3646a8c60c604fb019e90a90a551a6cf0ba6">PURPOSE</tsl-label>
            <tsl-select [formControl]="purposeControl" shape="round">
                <tsl-option *ngFor="let type of addressTypes" [value]="type.name">
                    {{ translate.get(type.name) }}
                </tsl-option>
            </tsl-select>
            <tsl-error *ngIf="purposeControl.errors && (purposeControl.dirty || purposeControl.touched)">
                <span i18n="@@42e81694bdce54d03ef0ce61856a2879d9b76e4e" t="42e81694bdce54d03ef0ce61856a2879d9b76e4e"> Purpose is Required </span>
            </tsl-error>
        </tsl-form-field>
    </div>
    <div class="col-6" *ngIf="purposeControl.value">
        <tsl-select-autocomplete #countryAutocomplete
            [tsl-labelText]="'COUNTRY'"
            [tsl-inputPlaceholder]="'Select country...'"
            [tsl-errorMessage]="'Country is Required'"
            [tsl-formControl]="countryControl"
            [tsl-options]="countries"
            [tsl-textFieldName]="'name'"
            [tsl-valueFieldName]="'abbreviation'">
        </tsl-select-autocomplete>
        <tsl-error style="font-size: 12px;" *ngIf="countryControl.hasError('CountrySelected')">
            <span i18n="@@2740236561190314005" t="2740236561190314005">Select country from the list</span>
        </tsl-error>
    </div>
</div>

<!-- Address/Street fields -->
<ng-container *ngIf="purposeControl.value">
    <div class="row">
        <div class="col pb-1">
            <tsl-form-field class="w-100">
                <tsl-label  i18n="@@ab5d5383363b934196b7246209f769d8163ff476" t="ab5d5383363b934196b7246209f769d8163ff476">STREET ADDRESS LINE 1</tsl-label>
                <input tslInput fullWidth maxlength="50" shape="round" [formControl]="addressLine1Control"
                    tPlaceholder="4523907648468761702" i18n-placeholder="@@4523907648468761702" placeholder="Address Line 1" />
                <tsl-hint align="below" class="max-length-hint">{{addressLine1Control.value?.length || 0}} / 50
                </tsl-hint>
                <tsl-error
                    *ngIf="addressLine1Control.errors && (addressLine1Control.dirty || addressLine1Control.touched)">
                    <span i18n="@@6653e5f2c38e2b52bd36a4796b3043464b017bb9" t="6653e5f2c38e2b52bd36a4796b3043464b017bb9"> Address is Required </span>
                </tsl-error>
            </tsl-form-field>
        </div>
        <div class="col pb-1">
            <tsl-form-field class="w-100">
                <tsl-label  i18n="@@3cb2e7ab7e09ef46944db3869accbbe6bdcc3fdc" t="3cb2e7ab7e09ef46944db3869accbbe6bdcc3fdc">STREET ADDRESS LINE 2</tsl-label>
                <input tslInput fullWidth maxlength="50" shape="round" [formControl]="addressLine2Control"
                    tPlaceholder="8231916530164206787" i18n-placeholder="@@8231916530164206787" placeholder="Address Line 2" />
                <tsl-hint align="below" class="max-length-hint">{{addressLine2Control.value?.length || 0}} / 50
                </tsl-hint>
            </tsl-form-field>
        </div>
    </div>

    <!-- City and State -->
    <div class="row">
        <div class="col py-1">
            <tsl-form-field class="w-100">
                <tsl-label i18n="@@595bc68a19d4f8202f72dbdd970f7b84bbf48caa" t="595bc68a19d4f8202f72dbdd970f7b84bbf48caa">CITY</tsl-label>
                <input id="city" tslInput type="text" fullWidth maxlength="30" shape="round" [formControl]="cityControl"
                    tPlaceholder="5c7012b5a926b32d9e45fefdcc8a1a3cb6f023d0" i18n-placeholder="@@5c7012b5a926b32d9e45fefdcc8a1a3cb6f023d0" placeholder="City" />
                <tsl-hint align="below" class="max-length-hint">{{cityControl.value?.length || 0}} / 30
                </tsl-hint>
                <tsl-error *ngIf="cityControl.errors && (cityControl.dirty || cityControl.touched)">
                    <span i18n="@@b1ceb2848a433a9e3d3d201889b9da60d59648e2" t="b1ceb2848a433a9e3d3d201889b9da60d59648e2">City is Required </span>
                </tsl-error>
            </tsl-form-field>
        </div>
        <div class="col py-1">
            <tsl-form-field class="w-100">
                <tsl-label i18n="@@d383b24f63b31a17e01e08ab2141adf17db20878" t="d383b24f63b31a17e01e08ab2141adf17db20878">STATE</tsl-label>
                <input id="state" tslInput fullWidth maxlength="30" shape="round" [formControl]="stateControl"
                    tPlaceholder="873b72903b1858a9cd6c8967521030b4d7d1435b" i18n-placeholder="@@873b72903b1858a9cd6c8967521030b4d7d1435b" placeholder="State" />
                <tsl-hint align="below" class="max-length-hint">{{stateControl.value?.length || 0}} / 30</tsl-hint>
                <div class="error" *ngIf="addressForm.hasError('state')" i18n="@@usstatevalidationMessage" t="usstatevalidationMessage">For country USA, State should be of 2 capital character abbreviation</div>
                <tsl-error *ngIf="stateControl.errors && stateControl.errors.required && (stateControl.dirty || stateControl.touched)">
                    <span i18n="@@eb5e63d466a879c0da4d461c29d36c97fc78cf30" t="eb5e63d466a879c0da4d461c29d36c97fc78cf30">State is Required </span>
                </tsl-error>
                <tsl-error *ngIf="stateControl.errors && stateControl.errors.USState && (stateControl.dirty || stateControl.touched)">
                    <span i18n="@@notavalidnameforusastates" t="notavalidnameforusastates">Not a valid State Name for Country USA.</span>
                </tsl-error>
            </tsl-form-field>
        </div>
    </div>

    <!-- Zipcode and Comments -->
    <div class="row">
        <div class="col-6 py-1">
            <tsl-form-field class="w-100">
                <tsl-label i18n="@@fa1886468aeda78829db050a6452f70178bbd212" t="fa1886468aeda78829db050a6452f70178bbd212">ZIP CODE</tsl-label>
                <input id="zipCode" tslInput type="text" fullWidth maxlength="10" shape="round"
                    [formControl]="zipCodeControl" tPlaceholder="ZipCode" i18n-placeholder="@@ZipCode" placeholder="Zip Code" />
                <tsl-hint align="below" class="max-length-hint">{{zipCodeControl.value?.length || 0}} / 10</tsl-hint>
                <tsl-error *ngIf="zipCodeControl.errors && zipCodeControl.errors.required && (zipCodeControl.dirty || zipCodeControl.touched)">
                    <span i18n="@@65048901e11b03cb13a6e3e276b661c0765cd3fe" t="65048901e11b03cb13a6e3e276b661c0765cd3fe">Zip Code is Required </span>
                </tsl-error>
                <tsl-error *ngIf="zipCodeControl.errors && zipCodeControl.errors.USZip && (zipCodeControl.dirty || zipCodeControl.touched)">
                    <span i18n="@@invalidUsZip" t="invalidUsZip">Please provide a valid US zip code.</span>
                </tsl-error>
            </tsl-form-field>
        </div>
        <div class="col py-1" *ngIf="showCommentsControl">
            <tsl-form-field class="w-100">
                <tsl-label i18n="@@6fb6e81ae931bf8ff64e50ce6c9ba435220c28ac" t="6fb6e81ae931bf8ff64e50ce6c9ba435220c28ac">COMMENTS</tsl-label>
                <input id="comments" tslInput fullWidth maxlength="100" shape="round" [formControl]="commentsControl"
                    tPlaceholder="1778798053384234221" i18n-placeholder="@@1778798053384234221" placeholder="Comments..." />
                <tsl-hint align="below" class="max-length-hint">{{commentsControl.value?.length || 0}} / 100</tsl-hint>
            </tsl-form-field>
        </div>
    </div>
    <div class="row" *ngIf="requiredDocuments?.length>0">
        <div class="col-12" >
            <h3 *ngIf="countryControl?.value != 'Mexico'" class="address-document-section-title" i18n="@@AddressTaskDocumentSectionHelpTitle" t="AddressTaskDocumentSectionHelpTitle">Optional Corresponding Document - Remittance Address</h3>
            <h3 *ngIf="countryControl?.value == 'Mexico'" class="address-document-section-title" i18n="@@AddressTaskDocumentSectionMandatoryHelpTitle" t="AddressTaskDocumentSectionMandatoryHelpTitle">Mandatory Corresponding Document - Remittance Address</h3>
            <div class="address-document-section-description-container">
                <tsl-icon size="small">info</tsl-icon>
                <span i18n="@@AddressTaskDocumentSectionHelpDescription" t="AddressTaskDocumentSectionHelpDescription">Please provide a corresponding document that refers to the remittance address of your organization.</span>
            </div>
            <div class="address-document-section-help-container">
                <p *ngIf="countryControl?.value != 'Mexico'" class="address-document-section-help" i18n="@@AddressTaskDocumentSectionHelp" t="AddressTaskDocumentSectionHelp">These are examples of accepted documents. Please choose and upload one of the following:</p>
                <ul *ngIf="countryControl?.value != 'Mexico'">
                    <li class="address-document-section-help-item" i18n="@@AddressTaskDocumentSectionHelpItem1" t="AddressTaskDocumentSectionHelpItem1">Tax Document (e.g., W-8 or W-9 form) displaying the name and address of your organization</li>
                    <li class="address-document-section-help-item" i18n="@@AddressTaskDocumentSectionHelpItem2" t="AddressTaskDocumentSectionHelpItem2">Posted mail displaying the name and address of your organization</li>
                    <li class="address-document-section-help-item" i18n="@@AddressTaskDocumentSectionHelpItem3" t="AddressTaskDocumentSectionHelpItem3">Lease agreement or mortgage statement</li>
                    <li class="address-document-section-help-item" i18n="@@AddressTaskDocumentSectionHelpItem4" t="AddressTaskDocumentSectionHelpItem4">Property tax receipt</li>
                    <li class="address-document-section-help-item" i18n="@@AddressTaskDocumentSectionHelpItem5" t="AddressTaskDocumentSectionHelpItem5">Telecom/Utility bill statements/ Invoice</li>
                </ul>
                <p class="address-document-section-help" i18n="@@AddressTaskDocumentSectionHelp2" t="AddressTaskDocumentSectionHelp2">The document must include the following:</p>
                <ul>
                    <li class="address-document-section-help-item" i18n="@@AddressTaskDocumentSectionHelp2Item1" t="AddressTaskDocumentSectionHelp2Item1">Your organization’s name</li>
                    <li class="address-document-section-help-item" i18n="@@AddressTaskDocumentSectionHelp2Item2" t="AddressTaskDocumentSectionHelp2Item2">Your organization’s remittance address</li>
                    <li class="address-document-section-help-item" i18n="@@AddressTaskDocumentSectionHelp2Item3" t="AddressTaskDocumentSectionHelp2Item3">A statement/posting date older than 3 months from today</li>
                </ul>
            </div>
        </div>
        <div class="col-12">
            <documents-grid #addressDocumentsGrid [tsl-supplierCode]="supplierCode" [tsl-documents]="requiredDocuments"
                [tsl-readOnly]="readOnly" [tsl-isReactivation]="isReactivation"></documents-grid>
        </div>
    </div>
</ng-container>

<!-- Save button -->
<div *ngIf="!hideSaveBtn" class="row">
    <div class="col text-right"><button color="blue" (click)="submit()"
            tsl-button>{{translate.get(saveButtonLabel)}}</button></div>
</div>
